import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import _, { debounce } from 'lodash';
import socket from '../../../../context/socket';
import YearSelect from '../../StartedYear/year';
import { fetchClientData } from '../../../../redux/client/clientSlice';
import { useDispatch } from 'react-redux';
import api from '../../../../utils/api';

const OtherData = ({ roomId, card_id, planYourGoals }) => {
  const dispatch = useDispatch();
  const [selectedCard, setSelectedCard] = useState(null);
  const [otherData, setOtherData] = useState({
    _id: card_id || '',
    amount: '',
    goalYear: '',
    startYear: '',
  });

  // Fetch the selected card and set the initial data
  useEffect(() => {
    if (!card_id) return;

    const defaultData = {
      _id: card_id,
      amount: '',
      goalYear: '',
      startYear: new Date().getFullYear().toString(),
    };

    const card = planYourGoals?.find((item) => item._id === card_id);
    setSelectedCard(card || null);

    if (card?.action_data?.[0]) {
      const { amount = '', goalYear = '', startYear = defaultData.startYear } = card.action_data[0];

      setOtherData({
        _id: card_id,
        amount,
        goalYear,
        startYear,
      });
    } else {
      setOtherData(defaultData);
    }
  }, [planYourGoals, card_id]);



  // Function to save data via API
  const saveData = async (updatedData) => {
    // Check if all required fields are filled
    const allFieldsFilled =
      updatedData._id !== "" &&
      updatedData.amount !== "" &&
      updatedData.goalYear !== "" &&
      updatedData.startYear !== "";

    // Add the status field to the data
    // const dataWithStatus = {
    //   ...updatedData,
    //   status: allFieldsFilled ? 1 : 0, // Status is 1 if all fields are filled, otherwise 0
    // };

    const newStatus = allFieldsFilled ? 1 : 0;
      const prevCreatedAt = selectedCard?.created_at;

      const dataWithStatus = {
        ...updatedData,
        status: newStatus,
      };

      const payload = {
        _id: roomId,
        dream_id: card_id,
        action_data: [dataWithStatus],
        status: newStatus,
      };

      // ✅ Add created_at ONLY ONCE at ROOT
      if (newStatus === 1 && !prevCreatedAt) {
        payload.created_at = new Date().toISOString();
      }

    try {
      const response = await api.post(`advisor/save_goal_data`,payload);
      dispatch(fetchClientData(roomId));

      console.log("Data saved successfully:", response.data);
    } catch (error) {
      console.error("Error saving data:", error);
    }
  };


  // Debounced save function
  const debouncedSaveData = useCallback(
    debounce((updatedData) => saveData(updatedData), 500),
    [card_id]
  );

  // Handle input changes and update state
  const handleInputChange = (field, value) => {
    const updatedData = {
      ...otherData,
      [field]: value,
    };
    setOtherData(updatedData);

    // Trigger the debounced save function
    debouncedSaveData(updatedData);
  };




  // Joining socket room
  useEffect(() => {
    socket.emit("join", roomId);
  }, [roomId]);

  const debouncedEmitMessage = useCallback(
    _.debounce(() => {
      console.log("emitted data", selectedCard, otherData,);
      socket.emit("message", {
        room: roomId,
        data: {
          selectedCard,
          otherData,
        },
      });
    }, 300),
    [
      selectedCard,
      roomId,
      otherData,
    ]
  );

  useEffect(() => {
    debouncedEmitMessage();
  }, [
    selectedCard,
    debouncedEmitMessage,
    otherData,
  ]);
  return (
    <>
      {/* Amount to save */}
      <div className="row ps-3">
        <div className="col-md-1 col-2 heartwidth">
          <img src="assets/images/heart.png" alt="" />
        </div>
        <div className="col-md-9 col-10">
          <p className="fs-21 lh-sm">
            I would like to save up
            <span className="clrgreen fw-semibold">
              {" "}₹{" "}
              <input
                type="number"
                style={{
                  border: 'none',
                  borderBottom: '1px solid green',
                  width: `${otherData.amount.length + 3}ch`,
                  paddingLeft: '1rem',
                  minWidth: '4ch',
                }}
                value={otherData.amount}
                // onChange={(e) => handleInputChange('amount', e.target.value)}
                onChange={(e) => {
                  const value = e.target.value;
                  if (value === "" || Number(value) >= 0) {
                    handleInputChange("amount", value)
                  }
                }}
                className="clrgreen fw-bold ps-3 moinput"
                placeholder="0"
              />
            </span>{' '}
            by
            <input
              type="text"
              style={{
                border: 'none',
                borderBottom: '1px solid green',
                width: `${otherData.goalYear.length + 3}ch`,
                paddingLeft: '1rem',
                minWidth: '7ch',
              }}
              value={otherData.goalYear}
              // onChange={(e) =>
              //   handleInputChange('goalYear', e.target.value)
              // }
              onChange={(e) => {
                const value = e.target.value;
                if (value === "" || Number(value) >= 0) {
                  handleInputChange("goalYear", value)
                }
              }}
              className="clrgreen fw-bold ps-3 moinput"
              placeholder="Year"
            />
          </p>
        </div>
      </div>

      {/* Start Year */}
      {/* <div className="row ps-3">
        <div className="col-md-1 col-2 heartwidth">
          <img src="assets/images/heart.png" alt="" />
        </div>
        <div className="col-md-9 col-10">
          <p className="fs-21 lh-sm">
            Start Year{' '}
            <span className="clrgreen fw-semibold">
              <select
                style={{
                  border: 'none',
                  borderBottom: '1px solid green',
                  width: `${otherData.startYear.length + 3}ch`,
                  paddingLeft: '1rem',
                  minWidth: '8ch',
                }}
                value={otherData.startYear}
                onChange={(e) => handleInputChange('startYear', e.target.value)}
                className="clrgreen fw-bold ps-3 moinput"
              >
                <option value="">Select</option>
                <option value="2024">2024</option>
                <option value="2025">2025</option>
                <option value="2026">2026</option>
              </select>
            </span>
          </p>
        </div>
      </div> */}

      <div className="row ps-3 align-items-center">
        <div className="col-md-1 col-2 heartwidth">
          <img src="assets/images/heart.png" alt="" />
        </div>

        <div className="col-md-9 col-10 d-flex align-items-center">
          <p className="fs-21 lh-sm me-2 pt-3">Start Year: </p>
          <div style={{ minWidth: "120px" }}>
            <YearSelect
              value={otherData.startYear}
              onChange={(val) =>
                handleInputChange("startYear", val)
              }
              recentYear={new Date().getFullYear()}
            />
          </div>
        </div>
      </div>

    </>
  );
};

export default OtherData;